import styled from "styled-components";
import { ThemePalette } from "../../../theme";

export const StyledProjectSection = styled.main`
  overflow-y: auto;

  .project-info-tabs {
    ol {
      list-style-type: none;
      padding-left: 1rem;

      li {
        display: inline-block;
        padding: 2rem;
      }
    }
  }

  .project-details {
    --scroll-container-height: 100%;
    display: flex;
    gap: 3rem;
    flex-basis: fit-content;

    .projects {
      border: 0.1rem solid ${ThemePalette.colorGrayLight};
      width: 23rem;
      padding: 2rem;
      outline: none;
      border-radius: 0.75rem;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      height: var(--scroll-container-height);
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.75rem;
      background: #fff;

      &::-webkit-scrollbar {
        display: none;
      }

      .ant-divider {
        margin: 0.5rem 0;
      }
    }

    .item {
      .title {
        color: ${ThemePalette.colorGrayDark};
        font-size: smaller;
        display: block;
      }
      .details {
        font-weight: bold;
        display: block;
      }
    }

    input {
      margin-left: 2rem;
      top: -0.2rem;
      width: 15rem;
    }

    .details {
      flex: 1;
      color: ${ThemePalette.colorGrayDarker};
      max-height: 78vh;

      .editable,
      .non-editable {
        flex: 2;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;
      }

      .editable {
        .detail {
          flex: 1;
        }
      }

      .detail {
        margin: 0 2rem;
        .detail-title {
          font-weight: 600;
        }
        .detail-value {
          font-weight: 500;
          font-size: 0.9em;
        }
      }
      .radio-buttons > * {
        margin-right: 3rem;
      }
    }
  }
`;

export const StyledUnderlineNavBar = styled.div`
  display: flex;
  width: fit-content;
  width: fit-content;
  ol {
    list-style-type: none;

    li {
      display: inline-block;
      margin-right: 2rem;
      height: 1.7rem;

      a {
        display: block;
        height: 100%;
        text-decoration: none;
        color: inherit;
      }
    }
    .nav-item {
      margin-left: 0.6rem;
    }
  }

  .nav-bar {
    color: black;
    padding-left: 2rem;
    margin-bottom: 1rem;

    .nav-item {
      position: relative;
      cursor: pointer;
      font-weight: 600;
      margin-left: 0.6rem;

      &::before {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        padding-bottom: 0.8rem;
        border-bottom: 0.125rem solid ${ThemePalette.colorPrimaryGradientTo};
        text-align: center;
        width: 100%;
      }

      &:not(.selected)::before {
        left: -10%;
        width: 0%;
      }

      &:not(.selected):hover::before {
        animation: line 0.2s linear forwards;
      }
    }
  }
`;

export const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-shadow: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ProjectDetailsContainer = styled.div`
  margin: 0;
  width: 100vw;
`;

export const StatusDisplayContainer = styled.div`
  padding: 1.2rem;
  background: ${ThemePalette.colorWhite};
  border-radius: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .import-message {
    margin: 0.5rem;
  }
  .import-time {
    margin-bottom: 1.2rem;
  }
`;
export const HorizontalLine = styled.hr`
  border: none;
  border-top: 0.1rem solid ${ThemePalette.colorGrayLight};
  margin: 0.5rem 1rem;
  width: 100%;
`;

export const Image = styled.div`
  background-image: url("/dashboard_calc_engine_white.svg");
  background-size: contain;
  background-position: center;
  width: 100vw;
  height: 72vh;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  overflow-y: hidden;
`;

export const ButtonContainer = styled.div`
  display: inline-block;
  padding-left: 1rem;
  button {
    padding: 0 0.5rem !important;
    border-radius: 0.5rem;
  }
`;

export const InputContainer = styled.div`
  flex: 1;
`;

export const WrapperDiv = styled.div`
  div {
    margin-left: 0 !important;
    padding-bottom: 0;
    display: inline-flex;
    align-items: center;
  }
  input {
    outline: 0.1rem solid ${ThemePalette.colorPrimary};
    border-radius: 0.2rem;
    padding: 0.1rem 0.5rem;
    width: 10rem;
    left: 0rem;
    border: none;
    border-bottom: 0.15rem solid rgba(0, 0, 0, 0);
  }
  input + span {
    border: 0.0625rem solid ${ThemePalette.colorPrimary};
    display: none;
  }
  span {
    width: 15rem;
  }
`;
